(function () {
    'use strict';

    function productSelectionController($scope, searchConfigurationDataService,
        sessionDataService) {
        var vm = this;
        vm.config = {};
        vm.sessionData = {};
        vm.results = [];
        vm.showResults = false;
        vm.attributes = {};
        vm.searchConfiguration = {};
        vm.project = {};

        vm.initialProductIds = [];

        vm.pageSizes = [5, 10, 15, 20, 25];

        $scope.init = function(project, extension) {
            vm.project = project;
            vm.extension = extension;

            //vm.config = searchConfigurationDataService.loadProductDefinitionsSearch(extension.ProductDefinitionSearchIndex,
            //        project.Id)
            //    .then(function(data) {
            //        vm.config = data;
            //    });

            vm.config = searchConfigurationDataService.loadProductDefinitionsSearch(extension.ProductDefinitionSearchIndex)
                .then(function (data) {
                    vm.config = data;
                });

            vm.sessionData = sessionDataService.loadSession().then(function(data) {
                vm.sessionData = data;
            });

            vm.initialProductIds = extension.ProductQualifications.map(function(item) {
                return {
                    ProductId: item.ProductId
                };
            });

            vm.toggleProductApplication = function (product, productQualifications) {
                var productIds = productQualifications.map(function (item) {
                    return item.ProductId;
                });
                var indexOfProductToAdd = productIds.indexOf(product.Id);
                if (indexOfProductToAdd !== -1) {
                    productIds.splice(indexOfProductToAdd, 1);
                    product.isSelected = false;
                }
                else {
                    productQualifications.push({
                        ProductId: product.Id,
                        Product: product,
                        Status: 'CompletingApplication'
                    });
                    product.isSelected = true;
                }
            }

        };

        vm.results = [];

        vm.extensionData = {};

    }

    productSelectionController.$inject = ['$scope', 'searchConfigurationDataService',
        'sessionDataService'];

    angular.module('ecap.workflow').controller('productSelectionController', productSelectionController);
})();
